module.exports = __webpack_public_path__ + "img/ss-stats.1f2a0bc8.jpg";